import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import imagesData from "./BeforeAfter.json";
import SVGTitle from "./SVGTitle";
import { t } from "i18next";

function BeforeAfter() {
  const allImages = imagesData.images;
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 4);
  };

  return (
    <div
      className="before-after py-5"
      id="before-after"
      style={{ backgroundColor: "#EFEFEF" }}
    >
      <div className="head text-center">
        <h2 className="mb-4 fs-1 fw-bolder">{t("BeforeAfter.heading")}</h2>
        <SVGTitle />
      </div>

      <div className="container">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true, el: ".swiper-pagination-custom" }}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mb-4"
        >
          {allImages.slice(0, 4).map((src, index) => (
            <SwiperSlide key={index}>
              <motion.div
                className="img-wrapper shadow rounded-4 overflow-hidden"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                onClick={() => setSelectedImage(src)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={src}
                  alt={`Before After ${index + 1}`}
                  className="w-100 h-100"
                  style={{ objectFit: "cover", borderRadius: "16px" }}
                  loading="lazy"
                />
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="swiper-pagination-custom text-center mt-3"></div>

        <div className="row g-4 justify-content-center mt-4">
          {allImages.slice(4, visibleCount).map((src, index) => (
            <motion.div
              key={index}
              className="col-6 col-md-4 col-lg-3"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              whileHover={{ scale: 1.05 }}
              onClick={() => setSelectedImage(src)}
              style={{ cursor: "pointer" }}
            >
              <div className="img-wrapper shadow rounded-4 overflow-hidden">
                <img
                  src={src}
                  alt={`Before After ${index + 5}`}
                  className="w-100 h-100"
                  style={{ objectFit: "cover", borderRadius: "16px" }}
                  loading="lazy"
                />
              </div>
            </motion.div>
          ))}
        </div>

        {visibleCount < allImages.length && (
          <div className="text-center">
            <button
              onClick={handleLoadMore}
              className="btn btn-info text-light px-4 py-2 fw-bold rounded-2 shadow"
            >
              {t("BeforeAfter.readMore")}
            </button>
          </div>
        )}
      </div>

      {selectedImage && (
        <div
          className="lightbox d-flex align-items-center justify-content-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.8)",
            zIndex: 9999,
          }}
          onClick={() => setSelectedImage(null)}
        >
          <motion.img
            src={selectedImage}
            alt="Selected"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4 }}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "20px",
              boxShadow: "0 0 20px rgba(255,255,255,0.5)",
            }}
          />
        </div>
      )}
    </div>
  );
}

export default BeforeAfter;
